module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Black.804b6c1c.woff";